import React from 'react';
import { GridColDef } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import SecurityIcon from '@mui/icons-material/Security';
import CustomDataGrid from '../../../../components/ui/customDataGrid/customDataGrid.component';
import { PERMISSION_GROUPS_URL } from '../../../../api/permissions';
import styles from './tenantPermissionGroups.module.css';
import { useHasPermission } from '../../../../contexts/auth';

export const TenantPermissionGroups = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const canViewGroups = useHasPermission("auth.view_group");

  const columns: GridColDef[] = [
    {
      field: 'id',
      headerName: 'ID',
    },
    {
      field: 'name',
      headerName: t('Name'),
    },
    {
      field: 'is_service_role',
      headerName: t('Members can be assigned to jobs as technicians'),
      type: 'boolean',
      flex: 1,
    },
  ];

  const handleRowClick = (id: string) => {
    navigate(`/tenant/permission-groups/${id}`);
  };

  if (!canViewGroups) {
    return null;
  }

  return (
    <Box className={styles.container}>
      <CustomDataGrid
        icon={<SecurityIcon />}
        title={t('Permission Groups')}
        url={PERMISSION_GROUPS_URL}
        gridSettingsKey="TENANT_PERMISSION_GROUPS"
        columns={columns}
        refreshEventName="permissionGroupsUpdated"
        onRowClick={handleRowClick}
      />
    </Box>
  );
};
